import * as React from 'react';

var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgShoppingBasketStar = function SvgShoppingBasketStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m17.956 11.68 1.544 4.07h2.994a.735.735 0 0 1 .518 1.283l-2.6 1.815 1.44 3.314a.785.785 0 0 1-1.117.982l-3.485-1.961-3.48 1.961a.785.785 0 0 1-1.117-.982l1.44-3.314-2.6-1.815a.734.734 0 0 1 .514-1.283h3l1.541-4.07a.794.794 0 0 1 1.408 0Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.875 17.25H4.314a1.442 1.442 0 0 1-1.383-1.136l-2.138-9A1.484 1.484 0 0 1 2.176 5.25h18.148a1.485 1.485 0 0 1 1.383 1.864l-.3 1.256M3.75 5.25l4.5-4.5M18.75 5.25 14.25.754"
  })));
};

export { SvgShoppingBasketStar as default };
//# sourceMappingURL=shopping-basket-star.svg.js.map
